export default "__VITE_ASSET__Dkfz3Uh0__"